/** Handles canonical API errors and validation errors from the OpenAPI validator. */
export function apiErrorMessage(value: unknown): string {
  if (typeof value === "string" && value.trim()) return value;
  if (value && typeof value === "object") {
    const record = value as Record<string, unknown>;
    if (Array.isArray(record.issues)) {
      const messages = record.issues.flatMap((issue: unknown) => {
        if (!issue || typeof issue !== "object") return [];
        const item = issue as Record<string, unknown>;
        if (typeof item.message !== "string") return [];
        const path = Array.isArray(item.path) ? item.path.join(".") : "";
        return [path ? `${path}: ${item.message}` : item.message];
      });
      if (messages.length) return messages.join("; ");
    }
    if (typeof record.message === "string" && record.message.trim()) return record.message;
  }
  return "The request failed. Please try again.";
}
